import * as React from "react";
import {
  DropDownTree,
  DropDownTreeChangeEvent,
  DropDownTreeExpandEvent,
} from "@progress/kendo-react-dropdowns";
import { processTreeData, expandedState } from "./tree-data-operations";
import { useStyles } from "./Document.styles";
import { useIntl } from "react-intl";
import { CheckBox } from "@material-ui/icons";
const selectField = "selected";
const expandField = "expanded";
const dataItemKey = "id";
const textField = "name";
const subItemsField = "children";
const fields = { selectField, expandField, dataItemKey, subItemsField };

const DropDownItem = ({ data, restrict, handleChange, selectValue }) => {
  const [expanded, setExpanded] = React.useState([data[0][dataItemKey]]);
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const onChange = (event: DropDownTreeChangeEvent) => {
    handleChange(event.value);
  };
  const onExpandChange = React.useCallback(
    (event: DropDownTreeExpandEvent) =>
      setExpanded(expandedState(event.item, dataItemKey, expanded)),
    [expanded]
  );
  let treeData: any = React.useMemo(
    () => processTreeData(data, { expanded, selectValue }, fields),
    [expanded, selectValue, data]
  );
  let MyItem = (data: any) => {
    return (
      <>
        <div className={classes.restrict}>
          <span style={data?.item?.restrictUploads ? { color: "gray" } : {}}>{data?.item?.name}</span>
          {/* {data?.item?.restrictUploads ? (
            <span className={classes.restrictIcon}>
              <CheckBox className={classes.chackBox} />
            </span>
          ) : (
            ""
          )} */}
        </div>
      </>
    );
  };
  return (
    <div>
      <DropDownTree
        label={formatMessage({
          id: "customer.create.group.file",
          defaultMessage: "Select folder",
        })}
        className={classes.treeDropDown}
        data={treeData}
        value={selectValue}
        onChange={onChange}
        placeholder={formatMessage({
          id: "customer.create.group.file",
          defaultMessage: "Select folder",
        })}
        textField={textField}
        dataItemKey={dataItemKey}
        selectField={selectField}
        expandField={expandField}
        onExpandChange={onExpandChange}
        item={MyItem}
        subItemsField={subItemsField}
      />
    </div>
  );
};

export default DropDownItem;
